import Dashboard from '../containers/Dashboard';
import Inventory from '../containers/Inventory';
import InventoryHistory from '../containers/InventoryHistory';
import LockDetails from '../containers/LockDetails';
import Properties from '../containers/Properties';
import PropertyDetails from '../containers/PropertyDetails';
import ProfitCenter from '../containers/ProfitCenter';
import Insights from '../containers/Insights';
// import WorkBench from '../containers/WorkBench';
import Customers from '../containers/Customers';
import CustomerDetails from '../containers/CustomerDetails';
import Visits from '../containers/Visits';
import Offers from '../containers/Offers';
import OfferDetails from '../containers/OfferDetails';
import Account from '../containers/Account';
import Integrations from '../containers/Integrations';
import Agents from '../containers/Agents';
import AgentForm from '../containers/AgentForm';
import InvoiceDetails from '../containers/InvoiceDetails';
import Communities from '../containers/Communities';
import Teams from '../containers/Teams';
import TeamForm from '../components/TeamForm';
import CommunityDetails from '../containers/CommunityDetails';
import CommunityAddForm from '../components/CommunityAddForm';
import ScheduledVisits from '../containers/ScheduledVisit';
import ScheduledVisitDetails from '../containers/ScheduledVisitDetails';
import InputProperty from '../components/PropertyInput';
import BuilderSettingsForm from '../components/BuilderSettingsForm';
import BuilderContentSettingsForm from '../components/BuilderContentSettingsForm';
import AfterTourHours from '../containers/AfterTourHours';
import Webhooks from '../containers/Webhooks';
import WebhookForm from '../components/WebhookForm';
import Reports from '../containers/Reports';
import ReportVisit from '../containers/ReportVisit';
import Training from '../containers/Training';
import SurveyQuestions from '../containers/SurveyQuestions';
import ReportPropertyVisit from '../containers/ReportPropertyVisit';
import Disclosures from '../components/Disclosures';
import MarketsReport from '../containers/ReportMarket';
import Messaging from '../components/Messaging';
import Devices from '../containers/Devices';
import AddForm from '../containers/Devices/AddForm';
import Share from '../containers/Share';
import BillingQuickbook from '../containers/BillingQuickbook';
import BillingDFO from '../containers/BillingDFO';
import SalesTraining from "../containers/SalesTraining";
import SurveyPostTourQuestions from '../containers/SurveyPostTourQuestions';
import ReportMonthly from '../containers/ReportMonthly';
import ReportOpportunity from '../containers/ReportOpportunity';
import ActivationMap from '../containers/ActivationMap';
import ActivationMapDetails from '../containers/ActivationMapDetails';

const routes = [
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/training', name: 'Training', component: Training },
  { path: '/sales-training', name: 'Sales Training', component: SalesTraining },
  { path: '/account/billing/invoices/:id', name: 'Account', component: InvoiceDetails },
  { path: '/account/billing/paid/:id', name: 'Account', component: InvoiceDetails },
  { path: '/account/billing/past-due/:id', name: 'Account', component: InvoiceDetails },
  // commented out, bsc we don't want to show this yet
  { path: '/inventory/:lockSerial', name: 'LockDetails', component: LockDetails },
  { path: '/inventory', name: 'Inventory', component: Inventory, roles: ['USER', 'PM'] },
  { path: '/inventory-history', name: 'Inventory History', component: InventoryHistory, roles: ['USER', 'PM'] },
  { path: '/devices/:id', name:'Add Device', component: AddForm},
  { path: '/devices', name:'Devices', component: Devices},
  { path: '/afterTourHours', name: 'After Tour Hours', component: AfterTourHours, roles: ['USER', 'PM'] },
  { path: '/visits', name: 'Visits', component: Visits, roles: ['USER', 'PM'] },
  { path: '/properties/add', name: 'PropertyInput', component: InputProperty, roles: ['USER', 'PM'] },
  { path: '/properties/:propertyId', name: 'PropertyDetails', component: PropertyDetails, roles: ['USER', 'PM'] },
  { path: '/properties', name: 'Properties', component: Properties, roles: ['USER', 'PM'] },
  { path: '/reportPropertyTours', name: 'Report Property Tours', component: ReportPropertyVisit },
  { path: '/reports', name: 'Reports', component: Reports, roles: ['USER', 'PM'] },
  { path: '/messaging', name: 'Messaging', component: Messaging, roles: ['USER', 'PM'] },
  { path: '/billing', name: 'BillingQuickbook', component: BillingQuickbook, roles: ['USER', 'PM'] },
  { path: '/billing-dfo', name: 'BillingDFO', component: BillingDFO, roles: ['USER', 'PM'] },
  { path: '/reportVisit', name: 'Report Visit', component: ReportVisit },
  { path: '/reportMarket', name: 'Report Market', component: MarketsReport },
  { path: '/reportMonthly', name: 'Report Monthly', component: ReportMonthly },
  { path: '/opportunities', name: 'Opportunities', component: ReportOpportunity },
  { path: '/profit-center', name: 'Profit Center', component: ProfitCenter },
  { path: '/integrations', name: 'Integrations', component: Integrations },
  { path: '/customers/:customerId', name: 'CustomerDetails', component: CustomerDetails, roles: ['USER', 'PM'] },
  { path: '/customers', name: 'Customers', component: Customers, roles: ['USER', 'PM'] },
  { path: '/insights', name: 'Insights', component: Insights },
  // { path: '/workbench', name: 'WorkBench', component: WorkBench },
  { path: '/account', name: 'Account', component: Account },
  { path: '/agents/add', name: 'AgentForm', component: AgentForm },
  { path: '/agents/:username', name: 'Agent details', component: AgentForm },
  {
    path: '/agents', name: 'Agents', component: Agents, roles: ['PM'],
  },
  { path: '/communities/add', name: 'CommunityAdd', component: CommunityAddForm, roles: ['USER', 'PM'] },
  { path: '/communities/:communityId', name: 'CommunityDetails', component: CommunityDetails, roles: ['USER', 'PM'] },
  { path: '/communities', name: 'Communities', component: Communities, roles: ['USER', 'PM'] },
  { path: '/teams/add', name: 'TeamForm', component: TeamForm },
  { path: '/teams/:teamId', name: 'TeamForm', component: TeamForm },
  { path: '/teams', name: 'Teams', component: Teams, roles: ['USER', 'PM'] },
  { path: '/schedule-visit/:scheduledVisitId', name: 'ScheduledVisitDetails', component: ScheduledVisitDetails, roles: ['USER', 'PM'] },
  { path: '/schedule-visit', name: 'ScheduledVisits', component: ScheduledVisits, roles: ['USER', 'PM'] },
  { path: '/offers/:offerId', name: 'OfferDetails', component: OfferDetails, roles: ['USER', 'PM'] },
  { path: '/offers', name: 'Offers', component: Offers, roles: ['USER', 'PM'] },
  { path: '/settings', name: 'Settings', component: BuilderSettingsForm, roles: ['USER', 'PM'] },
  { path: '/content-settings', name: 'Content Settings', component: BuilderContentSettingsForm, roles: ['USER', 'PM'] },
  // Webhooks
  { path: '/webhooks/add', name: 'WebhookForm', component: WebhookForm, roles: ['USER', 'PM'] },
  { path: '/webhooks/:webhookId', name: 'WebhookForm', component: WebhookForm, roles: ['USER', 'PM'] },
  { path: '/webhooks', name: 'Webhooks', component: Webhooks, roles: ['USER', 'PM'] },
  { path: '/pre-tour-survey', name: 'SurveyQuestions', component: SurveyQuestions, roles: ['USER', 'PM'] },
  { path: '/post-tour-survey', name: 'SurveyQuestions', component: SurveyPostTourQuestions, roles: ['USER', 'PM'] },
  {
    path: '/disclosures', name: 'Disclosures', component: Disclosures, roles: ['USER', 'PM'],
  },
  { path: '/share', name: 'Share', component: Share },
  { path: '/activation-map/:serialNumber', name: 'ActivationMapDetails', component: ActivationMapDetails },
  { path: '/activation-map', name: 'Activation Map', component: ActivationMap },
];

export default routes;
